export enum StripeSubscriptionStatusEnum {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  ENDED = 'ended',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  TRAILING = 'trialing',
  UNPAID = 'unpaid',
}
